import { min, max } from 'd3-array';

import Indicator from '../Indicator';
import subpixel from '../util/canvasSubpixelOffset';

/** Mass index indicator */
export default class MassIndexIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indciator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} extraInputs - Extra indicator inputs
	 */
	_getDefaultParams() {
		return {
			id: 'massindex',
			name: 'Mass Index',
			description: 'The Mass Index helps to identify reversals of trend.',
			inputs: [{ name: 'period', value: 25 }],
			extraInputs: [
				{ name: 'setup', value: 27 },
				{ name: 'trigger', value: 26.5 }
			],
			componentSeries: [
				{ id: 'massindex' }
			]
		};
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range minimum
	 */
	getRangeMin(data) {
		return this._min(
			min(data.massindex || [], i => +i.massindex),
			this.getInput('setup'),
			this.getInput('trigger')
		);
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range maximum
	 */
	getRangeMax(data) {
		return this._max(
			max(data.massindex || [], i => +i.massindex),
			this.getInput('setup'),
			this.getInput('trigger')
		);
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		const { panel } = this;
		const ctx = panel.rootContext;
		const x = panel.size.padding.left;
		const w = panel.size.width;
		const style = this.params.style;

		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});

		// setup line
		const ySetup = this.yScale(this.getInput('setup'));
		ctx.lineWidth = style.setup.width;
		ctx.strokeStyle = style.setup.color;
		if (style.setup.lineDash) {
			ctx.setLineDash(style.setup.lineDash.split(/\s*,\s*/));
		}
		ctx.beginPath();
		subpixel.moveTo(ctx, x, ySetup);
		subpixel.lineTo(ctx, x + w, ySetup);
		ctx.stroke();
		ctx.setLineDash([]);

		// trigger line
		const yTrigger = this.yScale(this.getInput('trigger'));
		ctx.lineWidth = style.trigger.width;
		ctx.strokeStyle = style.trigger.color;
		if (style.trigger.lineDash) {
			ctx.setLineDash(style.trigger.lineDash.split(/\s*,\s*/));
		}
		ctx.beginPath();
		subpixel.moveTo(ctx, x, yTrigger);
		subpixel.lineTo(ctx, x + w, yTrigger);
		ctx.stroke();
		ctx.setLineDash([]);
	}
}
